import * as React from "react"
import { Button } from "./button"
import { IButtonProps } from "./buttons.interface"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { isIpad } from "../../../util/deviceType"

const _SecondaryButton: React.FC<IButtonProps> = ({
  isMobile,
  ...otherProps
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <Button
      width="100%"
      bg={roomStyles?.secondaryAccessButtonBackgroundColor ?? "#1AC541"}
      borderColor={
        roomStyles?.secondaryAccessButtonBorderColor ?? "transparent"
      }
      border={
        roomStyles?.secondaryAccessButtonBorderColor
          ? `1px solid ${
              roomStyles?.secondaryAccessButtonBorderColor
                ? roomStyles.secondaryAccessButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={roomStyles?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
      _hover={
        isMobile || isIpad()
          ? {}
          : {
              backgroundColor:
                roomStyles?.secondaryAccessButtonMouseoverColor ?? "#24A840",
              textColor:
                roomStyles?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
            }
      }
      pointerEvents={otherProps.isDisabled ? "none" : "unset"}
      _disabled={{ opacity: 0.25 }}
      {...otherProps}
    />
  )
}

export const SecondaryButton = React.memo(_SecondaryButton)
